

































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { cards, enableCardTic } from '@/config';
import router from '@/router';

@Component({ mixins: [CompanyMixin] })
export default class SidebarCompany extends Vue {
  mounted() {
    const route = this.$router.currentRoute;
    if (
      route.params.OrgNr &&
      route.matched.length > 0 &&
      route.matched[route.matched.length - 1].path.startsWith('/:OrgNr')
    ) {
      user.checkCompany(route.params.OrgNr);
    }
  }

  clearSie() {
    user.setActiveSie(null);
  }

  get activeSie() {
    return user.activeSie !== null;
  }

  get OrgNr() {
    return this.$route.params.OrgNr;
  }

  get UserIdEx() {
    return user.activeExternalUser;
  }

  get includeValuation() {
    return cards.includes('valuation');
  }

  get enableCardTic() {
    return enableCardTic;
  }

  get aiInsightsEnabled() {
    return !!user.user && user.user.AiInsightsEnabled === true;
  }

  get params() {
    return { OrgNr: this.OrgNr };
  }

  get isGlobal() {
    return router.currentRoute.params.OrgNr === '00';
  }
}
